import apiClient, { getApiBaseUrl } from '../services/api';

// Import gender-specific avatar images
import maleAvatarImg from '../assets/avatar/avatar-male-doctor.jpg';
import femaleAvatarImg from '../assets/avatar/avatar-female-doctor.jpg';

// Helper function to get image URL from API
export const getImageUrl = (imageId) => {
  if (!imageId) return null;
  return `${getApiBaseUrl()}/images/${imageId}`;
};

// Helper function to load image data and create blob URL
export const loadImageFromDb = async (imageId) => {
  try {
    if (!imageId) return null;
    
    const blob = await apiClient.getImage(imageId);
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error loading image from API:', error);
    return null;
  }
};

// Clean up blob URLs to prevent memory leaks
export const cleanupImageUrl = (url) => {
  if (url && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
};

// Gender-based avatar fallback function
export const getGenderAvatar = (gender) => {
  switch (gender?.toLowerCase()) {
    case 'female':
      return femaleAvatarImg;
    case 'male':
    case 'other':
    default:
      return maleAvatarImg;
  }
};

export const getDoctorImageId = (doctor) => doctor?.imageId || doctor?.image_id || null;

// Get appropriate avatar based on doctor data
export const getDoctorAvatar = async (doctor) => {
  if (doctor?.image) {
    if (
      doctor.image.startsWith('data:') ||
      doctor.image.startsWith('http://') ||
      doctor.image.startsWith('https://') ||
      doctor.image.startsWith('blob:')
    ) {
      return doctor.image;
    }
  }

  const imageId = getDoctorImageId(doctor);
  if (imageId) {
    try {
      const customImage = await loadImageFromDb(imageId);
      if (customImage) {
        return customImage;
      }
    } catch (error) {
      console.error('Error loading custom doctor image:', error);
    }
  }

  return getGenderAvatar(doctor?.gender);
};

// Default placeholder image with doctor icon (kept for backward compatibility)
export const DEFAULT_DOCTOR_IMAGE = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZTNmMmZkIi8+CiAgPGNpcmNsZSBjeD0iMTAwIiBjeT0iNzAiIHI9IjMwIiBmaWxsPSIjOTRhM2I4Ii8+CiAgPHBhdGggZD0iTTcwIDEzMGMwLTMwIDEzLjUtNDAuNSAzMC00MC41czMwIDEwLjUgMzAgNDAuNXYzMEg3MHoiIGZpbGw9IiM5NGEzYjgiLz4KICA8Y2lyY2xlIGN4PSIxMDAiIGN5PSI3MCIgcj0iMjAiIGZpbGw9IiNmZmYiLz4KICA8dGV4dCB4PSI1MCUiIHk9IjE4NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEyIiBmaWxsPSIjNjY3Iix0ZXh0LWFuY2hvcj0ibWlkZGxlIj5Eb2N0b3I8L3RleHQ+Cjwvc3ZnPg==';